import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from "@bonprix/pattern-library/components/messages";

const breakpoints = {
    small: 320,
    medium: 480,
    large: 768,
    xlarge: 992,
    max: 1200
};

let currentBreakpoint

function determineBreakpoint() {
    const viewportWidth = window.innerWidth;
    let breakpointKey = 'small';

    if (viewportWidth >= breakpoints.max) {
        breakpointKey = 'max';
    } else if (viewportWidth >= breakpoints.xlarge) {
        breakpointKey = 'xlarge';
    } else if (viewportWidth >= breakpoints.large) {
        breakpointKey = 'large';
    } else if (viewportWidth >= breakpoints.medium) {
        breakpointKey = 'medium';
    }

    currentBreakpoint = {
        key: breakpointKey,
        value: breakpoints[breakpointKey]
    };

    return currentBreakpoint;
}

determineBreakpoint();

MessageBroker.subscribe(Messages.WINDOW.RESIZED, determineBreakpoint);

function current() {
    if(!currentBreakpoint) {
        return determineBreakpoint();
    }
    return currentBreakpoint;
}
function keyIsIn(breakpoints) {
    const key = current().key;
    return breakpoints.find(breakpoint => breakpoint === key) !== undefined;
}

export default {
    current,
    keyIsIn,
};